// @flow
import container from '../platform/container'
import Request from '../platform/request'

import Storage from '../platform/storage'

const request = new Request()
const storage = new Storage()

export { container, request, storage }
